const binding = { modules: {}, dataActions: {} };

    (binding.modules['cip-image'] = {
        c: () => require('partner/modules/cip-image/cip-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-image'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|cip-image|cip-image'] = {
                c: () => require('partner/modules/cip-image/cip-image.view.tsx'),
                cn: '__local__-__local__-cip-image'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };